var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"design",attrs:{"id":"top-fixed-content"}},[_c('app-header',{staticClass:"fix-position-box",attrs:{"id":"layout-header"}})],1),_c('div',{attrs:{"id":"under-top-content"}},[_c('router-view')],1),_c('spinner',{attrs:{"show":_vm.loading}},[_vm._v("load")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }